import { AllyBase } from "../base";
import { AllyElementBase } from "./ally-element-base.class";

/**
 * --- This class provides part of the function matrix created by the AllyElements object. ---
 * 
 * This class is used to get the angular host id and propagate it through the DOM.
 * 
 * @extends AllyElementBase
 * @see AllyElements
 * @see AllyAngular["getHost"]
 */
export class AllyHostElement extends AllyElementBase {
    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(bridge: () => AllyBase) {
        super(bridge, (matrix) => {
            matrix[1].push(
                (scope) => {
                    let hostId = scope.self.library.angular.getHost(scope.self.node);
                    if (hostId) {
                        scope.self.variables.hostId = hostId;
                    } else if (scope.self.parentObject?.variables.hostId) {
                        scope.self.variables.hostId = scope.self.parentObject.variables.hostId;
                    }
                }
            );
        }, 1);
    }
}